import { useCallback, useMemo, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { ChatIaFlutuante } from '@spark/chat-ia';
import { useAuth } from '@/context/AuthContext';
import { useNotificacoesAlert } from '@/context/NotificacoesAlertContext';
import {
  COGNITO_GROUP_CHAT_IA_PROGRAMACAO,
  COGNITO_GROUP_CHAT_IA_PROGRAMACAO_HAVAN,
} from '@/utils/cognitoGroups';
import { nomeDaTela } from './nomesDeTelas';

const MARGEM_PADRAO = 16;
const MARGEM_COM_BANNER = 88;

const avisarNaoAutorizado = () => {
  console.warn('Chat IA: acesso não autorizado ao assistente.');
};

/**
 * Monta o assistente flutuante nas telas `/pages` para quem tem um dos grupos do chat.
 * O elemento devolvido é sempre o mesmo `ChatIaFlutuante`, então navegar entre telas não o desmonta
 * (uma resposta em andamento sobrevive); só muda o `contexto`.
 */
const ChatIaGlobal = () => {
  const { isAuthenticated, user, hasCognitoGroup } = useAuth();
  const { bannerVisivel } = useNotificacoesAlert();
  const { pathname } = useLocation();

  const tokenRef = useRef(null);
  tokenRef.current = user?.accessToken ?? null;
  const obterToken = useCallback(() => tokenRef.current, []);

  const contexto = useMemo(
    () => [{ description: 'Tela atual', value: `${nomeDaTela(pathname) ?? 'Spark'} — ${pathname}` }],
    [pathname]
  );

  const habilitado = process.env.REACT_APP_CHAT_IA_ENABLED === 'true';
  const visivel =
    habilitado &&
    isAuthenticated &&
    !user?.isExternalUser &&
    pathname.startsWith('/pages') &&
    (hasCognitoGroup(COGNITO_GROUP_CHAT_IA_PROGRAMACAO) ||
      hasCognitoGroup(COGNITO_GROUP_CHAT_IA_PROGRAMACAO_HAVAN));

  if (!visivel) return null;

  return (
    <ChatIaFlutuante
      urlApi={process.env.REACT_APP_BASE_API_URL_SYNC}
      obterToken={obterToken}
      contexto={contexto}
      margemInferior={bannerVisivel ? MARGEM_COM_BANNER : MARGEM_PADRAO}
      aoNaoAutorizado={avisarNaoAutorizado}
    />
  );
};

export default ChatIaGlobal;
